module.exports = __webpack_public_path__ + "img/3.0df9a162.webp";